
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PdfDownloader } from "./PdfDownloader";

interface RecipeDetailsProps {
  recipe: {
    recipeName: string;
    ingredients: string[];
    instructions: string;
  };
}

export function RecipeDetails({ recipe }: RecipeDetailsProps) {
  if (!recipe) return null;
  
  return (
    <Card className="mt-4">
      <CardHeader className="flex flex-row items-start justify-between pb-2">
        <CardTitle className="text-xl">{recipe.recipeName}</CardTitle>
        <PdfDownloader 
          type="recipe"
          title={recipe.recipeName}
          content={recipe.ingredients}
          additionalInfo={recipe.instructions}
        />
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <h3 className="font-semibold text-lg mb-2">Ingredients</h3>
            <ul className="list-disc pl-5 space-y-1">
              {recipe.ingredients.map((ingredient, i) => (
                <li key={i}>{ingredient}</li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-2">Instructions</h3>
            <p className="whitespace-pre-wrap">{recipe.instructions}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
